import React, { useEffect , useState } from 'react';
import BreadCrumbs from '../components/breadcrumbs';
import Banner from '../components/banner';
import Cards from '../components/blogs_cards';
import DownContact from '../components/downcontact';
import RCMcy from '../images/BlogCardImgs/mainblogbanner1.webp';
import { Helmet } from 'react-helmet';
import ReactGA from 'react-ga';
ReactGA.initialize('G-7WQFXCQFVP');

const Blogs = () => {
  useEffect(() => {
    // change title of page
    document.title = 'Medical Billing Services|Medical Billing Outsource|Medical Billing Consultant';
    const script = document.createElement('script');
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-7WQFXCQFVP';
    script.async = true;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());

    gtag('config', 'G-7WQFXCQFVP');
    
  }, []);

  // Set Breadcrumb
  const [Breadcrumb, setBreadcrumb] = useState('Blogs');

  // Set Banner Title
  const [BannerTitle, setBannerTitle] = useState({img:`url(${RCMcy})`});

  // Set DownContact Heading
  const [DownContactTitle, setDownContactTitle] = useState({title: "WE HELP DOCTORS COLLECT MORE MONEY FASTER AND EASIER", subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."});

 return (
    <>
      <Helmet>
        <title> Medical Billing Blogs | Insights & Tips | Acer Health </title>
        <link rel="canonical" href="https://acerhealth.com/medical-billing-blogs" />
        <meta name="description" content="Follow Acer Health’s blog for expert tips and insights to enhance billing practices and streamline your revenue cycle." />
      </Helmet>
      {/* <BreadCrumbs Breadcrumb ={Breadcrumb} /> */}
      <Banner BannerTitle ={BannerTitle} />
      <Cards />
    </>

  );
};

export default Blogs;